<template>
	<v-card class="pa-3"> 
		<v-row>
			<v-col>
				<v-tabs class="mb-3" v-model="view">
					<v-tab>Paste</v-tab>
					<v-tab>Preview</v-tab>
				</v-tabs>
				<div v-if="view == 0">
					<v-label>Paste in rows, tab delimited</v-label>
					<v-textarea v-model="rawRows"></v-textarea>
					<v-label>Fields</v-label>
					<v-text-field v-model="fieldString"></v-text-field>
					<v-label>Defaults (can not be changed)</v-label>
					<p v-if="defaults" color="secondary" >
							{{ Object.keys(defaults).join(", ") }}
					</p>
				</div>
				<div v-if="view == 1">
					<v-data-table
						:headers="headers"
						:items="rows"
						:items-per-page="5"
						class="elevation-1 mb-2"
					>
					</v-data-table>
				</div>
				<p class="text-right">
					<v-btn color="green" dark @click="save">Save</v-btn>
				</p>
			</v-col>
		</v-row>
	</v-card>

</template>

<script>

export default {
	name: "Import",
	props: {
		'initialFields' : { type: Array },
		'defaults': { type: Object },
		'fieldFunctions': { type: Object },
	}, 
	components: {},
	data: () => ({
		fields: [],  
		view: 0,
		rawRows: '',
		fieldString: ''
    }),
    watch: {
		fieldString: function(){
			this.fields = this.fieldString.split(",")
		},
		fields: function(){
			this.fieldString = this.fields.join(",")
		}
    },
	computed: {
		headers: function(){
			return this.fields.map( field => { 
				return { text: field, value: field }
			} )
		},
		rows: function(){
			let rows = [];
			if( !this.rawRows ){ return rows; }
			this.rawRows.split("\n" ).forEach( r => {
				let row = {};
				let i = 0;
				this.fields.forEach( f => {
					row[f] = r.split("\t")[i];
					i++;
				})
				rows.push( row )
			} );
			return rows;
		}
	},
	methods: {
		save: function(){
			var self = this;
			let objects = [];
			this.rows.forEach( function( row ){
				let newObject = row;
				for( let key in self.defaults ){
					newObject[key] = self.defaults[key];
				}
				for( let key in self.fieldFunctions ){
					newObject[key] = self.fieldFunctions[key](newObject)
				}
				objects.push( newObject	 )
			})
				
			this.$emit("complete", objects);
		}
	},
	created: function(){
		this.fields = this.initialFields
	}
}
</script>